import React from 'react';
import AxisLogo from './SVGs/AxisLogo';
import AbcHospitalLogo from '../../assets/SVGs/logos/ABCHospitalLogo_transparent';

export const USE_ABC_HOSPITAL_AXIS_BRANDING = true;

type LogoSize = 'small' | 'medium' | 'large' | 'extra-large';
type LogoVariant = 'color' | 'white' | 'black';

export interface AxisBrandLogoProps {
  variant?: LogoVariant;
  size?: LogoSize;
  className?: string;
  style?: React.CSSProperties;
  onClick?: () => void;
}

interface AxisBrandingConfig {
  organizationName: string;
  phoneNumber: string;
  websiteUrl: string;
  renderLogo: React.FC<AxisBrandLogoProps>;
}

const getDimensions = (size: LogoSize = 'medium') => {
  switch (size) {
    case 'small':
      return { width: 160, height: 40 };
    case 'extra-large':
      return { width: 280, height: 80 };
    case 'large':
      return { width: 240, height: 60 };
    default:
      return { width: 200, height: 50 };
  }
};

const AxisDefaultLogo: React.FC<AxisBrandLogoProps> = (props) => (
  <AxisLogo {...props} />
);

const AbcHospitalLogoWrapper: React.FC<AxisBrandLogoProps> = ({
  size = 'medium',
  className = '',
  style,
  onClick,
}) => {
  const { width, height } = getDimensions(size);

  return (
    <div
      className={`axis-brand-logo ${className}`}
      style={{
        display: 'flex',
        alignItems: 'center',
        ...style,
      }}
      onClick={onClick}
    >
      <AbcHospitalLogo width={width} height={height} />
    </div>
  );
};

const defaultBranding: AxisBrandingConfig = {
  organizationName: 'Axis Integrated Mental Health',
  phoneNumber: '(720) 400-7025',
  websiteUrl: 'https://www.axismh.com/',
  renderLogo: AxisDefaultLogo,
};

const abcHospitalBranding: AxisBrandingConfig = {
  organizationName: 'Abc Hospital',
  phoneNumber: '(000) 000-0000',
  websiteUrl: 'https://abchospital.stage.stitchfinapp.com/',
  renderLogo: AbcHospitalLogoWrapper,
};

export const axisBranding: AxisBrandingConfig = USE_ABC_HOSPITAL_AXIS_BRANDING
  ? abcHospitalBranding
  : defaultBranding;

export const AxisBrandLogo: React.FC<AxisBrandLogoProps> = (props) => {
  const LogoComponent = axisBranding.renderLogo;
  return <LogoComponent {...props} />;
};

